var map = {
	"./amazon-logo.png": 994,
	"./dc-logo.png": 575,
	"./dell-logo.png": 729,
	"./disney-logo.png": 862,
	"./f5-logo.png": 979,
	"./filmarcade-logo.png": 572,
	"./fox-logo.png": 205,
	"./github-logo.png": 513,
	"./indigoslate-logo.png": 155,
	"./kraken-logo.png": 776,
	"./legendary-logo.png": 209,
	"./microsoft-logo.png": 700,
	"./netflix-logo.png": 304,
	"./paccar-logo.png": 936,
	"./paramount-logo.png": 275,
	"./pokemon-logo.png": 301,
	"./sap-logo.png": 344,
	"./sentinelone-logo.png": 828,
	"./sevenbucks-logo.png": 13,
	"./signal-logo.png": 302,
	"./skype-logo.png": 650,
	"./suno-logo.png": 225,
	"./ubisoft-logo.png": 618,
	"./valve-logo.png": 214,
	"./warnerbros-logo.png": 631,
	"./woodinville-logo.png": 358,
	"./xbox-logo.png": 95
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 179;